const MESSAGE = {
    PROD_CREDIT:
        "When enabled, the fee portion of item totals will be excluded from generating production when parent items are not eligible as opposed to default functionality where fees that are hidden and embedded (attached) within another item eligible to generate production credit will generate production credit regardless of parent item's eligibility."
};

export default {
    MESSAGE
};
